import { useMemo } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { getGetCardQueryOptions, useLinker } from './point-api/client';
import type { CardId, LinkerAction, ListId } from './point-api/model';

interface UseCardListLinkerProps {
  action: LinkerAction;
  cardIds: CardId[];
  listId: ListId;
  onSuccess?: VoidFunction;
}
function useCardListLinker({
  action,
  cardIds,
  listId,
  onSuccess = undefined,
}: UseCardListLinkerProps): () => Promise<void> {
  const queryClient = useQueryClient();
  const linker = useLinker({
    mutation: {
      onSuccess: () => {
        cardIds.forEach((cardId) => {
          // FIXME: orval генерирует кривой инвалидатор
          queryClient.invalidateQueries(getGetCardQueryOptions(cardId));
        });
        onSuccess?.();
      },
    },
  });

  return useMemo(
    () => async () => linker.mutateAsync({
      data: {
        list_id: listId,
        card_ids: cardIds,
        action,
      },
    }),
    [linker, listId, cardIds, action],
  );
}
export { useCardListLinker };
